import ErrorWithCause from '@helpers/ErrorWithCause';
import axios from 'axios';
import { SYMFONY_API_BASE_URL } from '@config/apiConfig';
const getAppContext = async () => {
    try {
        const { data } = await axios.get(`${SYMFONY_API_BASE_URL}/api/app-context/v1`);
        return data;
    }
    catch (error) {
        throw new ErrorWithCause(error);
    }
};
export default getAppContext;
